import { Typography } from '@mui/material'

import { Maybe } from '@/clients/utoniq-core/schema'
import { FullscreenModal } from '@/components/organisms/functionals'
import { OwnedItemDetailTemplate } from '@/components/pages/OwnedItemDetail/template'
import type {
  Action,
  State,
} from '@/components/pages/OwnedItemDetail/viewModel'
import { useTranslation } from '@/core'
import { Organism } from '@/core/architecture'

type Props = {
  open: boolean
  loading: boolean
  portfolio: Maybe<State['portfolio']>
  onClickShare: () => Promise<void>
  QRCodePrinting: boolean
  user: Maybe<State['user']>
  loggedUser: Maybe<State['loggedUser']>
  onClose?: () => void
  protectingItem: boolean
  onSettingAvatar: Action['onSettingAvatar']
  onSettingWallpaper: Action['onSettingWallpaper']
  onProtectUserItem: Action['onProtectUserItem']
  onImageDownload: Action['onImageDownload']
  onUseTicket: Action['onUseTicket']
  onGenerateWallpaperPrintQrcode: Action['onGenerateWallpaperPrintQrcode']
}

/**
 * ガチャ結果画面でアイテムをタップした際に表示されるアイテム詳細モーダル
 * OwnedItemDetailのテンプレートを表示する
 */
export const OwnedItemDetailModal: Organism<Props> = ({
  open,
  loading,
  portfolio,
  user,
  loggedUser,
  protectingItem,
  onClickShare,
  onSettingAvatar,
  onUseTicket,
  onSettingWallpaper,
  onProtectUserItem,
  onClose,
  onImageDownload,
  onGenerateWallpaperPrintQrcode,
  QRCodePrinting,
}) => {
  const { t } = useTranslation('ownedItemDetail')

  return (
    <FullscreenModal open={open} onClose={onClose}>
      {!portfolio?.item && !loading ? (
        <Typography variant="body1" sx={{ textAlign: 'center' }}>
          {t('itemNotFound')}
        </Typography>
      ) : (
        <OwnedItemDetailTemplate
          /**
           * @todo
           * ガチャ挙動修正PRにて修正を行う
           * https://app.clickup.com/t/908127/UT-3461
           */
          state={{
            loading: loading && !portfolio,
            customProfileUpdating: false,
            loadingOnce: false,
            portfolio,
            protectingItem,
            user,
            loggedUser,
            paymentSource: null,
            purchasablePrepaidPoints: null,
            enablePointCarrierPayment: false,
            point: 0,
            chargeLoading: false,
            purchasingItem: false,
            QRCodePrinting,
          }}
          onSettingAvatar={onSettingAvatar}
          onSettingWallpaper={onSettingWallpaper}
          onClickShare={onClickShare}
          onProtectUserItem={onProtectUserItem}
          onClose={onClose}
          onUseTicket={onUseTicket}
          onImageDownload={onImageDownload}
          onBuyItem={async () => {}}
          onPurchaseCharge={async () => {}}
          onViewCollectionMagazine={async () => {}}
          onGenerateWallpaperPrintQrcode={onGenerateWallpaperPrintQrcode}
        />
      )}
    </FullscreenModal>
  )
}
